// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1904":"9f30b8ff","4738":"7bd38256","5199":"7f8986ef","8527":"beb62157","9074":"c6551b35"}[chunkId] + ".chunk.css";
};